import TextFieldValidation from '@components/TextFieldValidation/TextFieldValidation';
import { Grid } from '@mui/material';
import React, { FC } from 'react';
import { CONNECTORS_FORM_KEYS, IConnectorEditDialog } from 'types/connectors';

const locale = {
	serviceName: `connectors.edit.dialog.form.field.serviceName`,
	serverAddress: `connectors.edit.dialog.form.field.serviceAddress`,
	port: `connectors.edit.dialog.form.field.port`,
	username: `connectors.edit.dialog.form.field.username`,
	password: `connectors.edit.dialog.form.field.password`,
	fromEmail: `connectors.edit.dialog.form.field.fromEmail`
};

const SmtpEditForm: FC<IConnectorEditDialog> = ({ formik, gridSpacing }) => (
	<Grid container spacing={gridSpacing}>
		<Grid item xs={12}>
			<TextFieldValidation
				autoFocus
				id={CONNECTORS_FORM_KEYS.serviceName}
				type="text"
				required
				formik={formik}
				label={intl.tr(locale.serviceName)}
				fullWidth
			/>
		</Grid>
		<Grid item container spacing={gridSpacing}>
			<Grid item xs={8}>
				<TextFieldValidation
					id={CONNECTORS_FORM_KEYS.host}
					type="text"
					required
					formik={formik}
					label={intl.tr(locale.serverAddress)}
					fullWidth
				/>
			</Grid>
			<Grid item xs={4}>
				<TextFieldValidation
					id={CONNECTORS_FORM_KEYS.port}
					type="number"
					required
					formik={formik}
					label={intl.tr(locale.port)}
					fullWidth
				/>
			</Grid>
		</Grid>
		<Grid item xs={12}>
			<TextFieldValidation
				id={CONNECTORS_FORM_KEYS.username}
				type="text"
				required
				formik={formik}
				label={intl.tr(locale.username)}
				fullWidth
			/>
		</Grid>
		<Grid item xs={12}>
			<TextFieldValidation
				id={CONNECTORS_FORM_KEYS.password}
				type="password"
				formik={formik}
				label={intl.tr(locale.password)}
				autoComplete="current-password"
				fullWidth
			/>
		</Grid>
		<Grid item xs={12}>
			<TextFieldValidation
				id={CONNECTORS_FORM_KEYS.fromEmail}
				type="email"
				required
				formik={formik}
				label={intl.tr(locale.fromEmail)}
				fullWidth
			/>
		</Grid>
	</Grid>
);

export default SmtpEditForm;
